import { DatePipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
} from '@angular/core';

import { IconModule } from '@hglobal/fin-ui';
import { TranslateModule } from '@ngx-translate/core';

import { Account, CardStatus } from '@iw/core/entities';
import { CardNumberPipe, IwDecimalPipe, MaskBalancePipe } from '@iw/core/pipes';

import { ButtonComponent } from '../../button';
import { TooltipComponent } from '../../tooltip';
import { CardViewSize } from '../card-view.model';

@Component({
  selector: 'iw-bank-card',
  imports: [
    IwDecimalPipe,
    DatePipe,
    ButtonComponent,
    IconModule,
    TranslateModule,
    CardNumberPipe,
    MaskBalancePipe,
    TooltipComponent,
  ],
  templateUrl: './bank-card.component.html',
  styleUrl: './bank-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BankCardComponent {
  readonly account = input<Account>();
  readonly size = input<CardViewSize>();
  readonly iconSize = input<Record<CardViewSize, number>>();
  readonly currentCard = input<Account>();
  readonly menuShown = input<boolean>();
  readonly useBalanceMask = input<boolean>(false);

  readonly action = output<Account>();

  readonly cardStatusEnum = CardStatus;

  statusConfig = computed(() => {
    const status = this.currentCard().card.status;

    const statusMap: Partial<
      Record<CardStatus, { titleKey: string; descriptionKey: string }>
    > = {
      [CardStatus.Creating]: {
        titleKey: 'cardView.bankCard.creating.title',
        descriptionKey: 'cardView.bankCard.creating.description',
      },
      [CardStatus.Activating]: {
        titleKey: 'cardView.bankCard.activating.title',
        descriptionKey: 'cardView.bankCard.activating.description',
      },
      [CardStatus.Closing]: {
        titleKey: 'cardView.bankCard.closing.title',
        descriptionKey: 'cardView.bankCard.closing.description',
      },
      [CardStatus.Blocking]: {
        titleKey: 'cardView.bankCard.blocking.title',
        descriptionKey: 'cardView.bankCard.blocking.description',
      },
    };

    return statusMap[status] || null;
  });

  failedStatusConfig = computed(() => {
    const status = this.currentCard().card.status;

    const failedStatusMap: Partial<
      Record<CardStatus, { titleKey: string; btnKey: string }>
    > = {
      [CardStatus.CreatingFailed]: {
        titleKey: 'cardView.bankCard.creatingFailed.title',
        btnKey: 'cardView.bankCard.creatingFailed.btn',
      },
      [CardStatus.ActivatingFailed]: {
        titleKey: 'cardView.bankCard.activatingFailed.title',
        btnKey: 'cardView.bankCard.activatingFailed.btn',
      },
      [CardStatus.BlockingFailed]: {
        titleKey: 'cardView.bankCard.blockingFailed.title',
        btnKey: 'cardView.bankCard.blockingFailed.btn',
      },
      [CardStatus.ClosingFailed]: {
        titleKey: 'cardView.bankCard.closingFailed.title',
        btnKey: 'cardView.bankCard.closingFailed.btn',
      },
    };

    return failedStatusMap[status] || null;
  });
}
